import { useRouter } from 'next/navigation'
import React from 'react'

import { IEmployee, IEmployeeReduced } from '@/_types'

import ATeamMemberCardButtons from './components/a-team-member-card-buttons'
import ATeamMemberCardHeader from './components/a-team-member-card-header'

interface TeamMemberProps {
	employee: IEmployee | IEmployeeReduced
	reservationButton: boolean
	orderUrl?: string
}

const ZTeamMemberCard: React.FC<TeamMemberProps> = ({ employee, reservationButton, orderUrl }) => {
	const router = useRouter()

	const handleShowDetail = (
		e: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLButtonElement>
	) => {
		e?.preventDefault()

		// if (
		// 	employee.categories?.some(
		// 		category => category.type === TEAM_CATEGORY_TYPE_ENUM.MEDICAL_PERSONNEL
		// 	)
		// ) {
		// 	router.push(`/tim/${employee.slug}`)
		// } else {
		// 	router.push(`/tim/${employee.slug}?other=true`)
		// }

		router.push(`/tim/${employee.slug}`)
	}

	return (
		<button
			className='employee h-full mb-5 text-medante-purple-dark cursor-pointer md:hover:scale-103 transition-all duration-300'
			onClick={handleShowDetail}
		>
			<div className='flex flex-col items-center justify-between w-full h-full p-4 text-center'>
				<ATeamMemberCardHeader employee={employee} />
				<ATeamMemberCardButtons
					employee={employee}
					reservationButton={reservationButton}
					handleShowDetail={handleShowDetail}
					orderUrl={orderUrl}
				/>
			</div>
		</button>
	)
}

export default ZTeamMemberCard
